import { Button } from '@moniebook-web/components/atoms/button';
import { StructuredModal } from '@moniebook-web/components/atoms/structured-modal';
import { Body } from '@moniebook-web/components/atoms/typography';

import { useSessionManager, useSessionTimer } from './hooks';

export function SessionManager() {
    const { isSessionExpired } = useSessionManager();
    const {
        showInactiveModal,
        countDown,
        handleLogout,
        handleContinueSession,
    } = useSessionTimer();

    return (
        <StructuredModal.Modal
            className='max-w-[423px]!'
            isOpen={showInactiveModal && !isSessionExpired}
            closeOnEscape={false}
            type='bottomsheet'>
            <StructuredModal.Header>
                <div className='mt-24 flex items-center justify-between md:mt-0!'>
                    <StructuredModal.Title className='font-general-sans text-content-heading-default!'>
                        Session timeout
                    </StructuredModal.Title>
                    <StructuredModal.CloseButton
                        onClick={handleContinueSession}
                    />
                </div>
            </StructuredModal.Header>
            <StructuredModal.Body className='mt-8'>
                <div className='flex flex-col'>
                    <Body className='text-content-subtext-alternative!'>
                        You’ve been inactive for over{' '}
                        <span className='font-medium'>1 hour</span>. To keep
                        your account secure, we’ll sign you out at the end of
                        the timer.
                    </Body>
                    <div className='flex items-center justify-center px-24 py-64'>
                        <h1 className='font-medium text-48 text-content-heading-default'>
                            {countDown}
                        </h1>
                    </div>
                </div>
            </StructuredModal.Body>
            <StructuredModal.Footer>
                <Button
                    label='Log out'
                    size='small'
                    onClick={handleLogout}
                    theme='secondary'
                    className='w-full'
                />
                <Button
                    label='Continue'
                    size='small'
                    onClick={handleContinueSession}
                    className='w-full'
                />
            </StructuredModal.Footer>
        </StructuredModal.Modal>
    );
}
